import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

import playGreen from "../../assets/LogsListAssets/playgreen.svg";
import stopGrey from "../../assets/LogsListAssets/stopgrey.svg";
import pauseOrange from "../../assets/LogsListAssets/pauseorange.svg";

import TasksListCommentBox from "./TasksListCommentBox";
import TaskListContents from "./TaskListContents";
import TasksListDropdown from "./TasksListDropdown";
import Layout from "../../utils/Layout";
import Pagination from "../ReUseable/Pagination/Pagination";
import { API } from "../../global";
import Loader from "../ReUseable/Loader/Loader";

const TasksList = () => {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tasks, setTasks] = useState([]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = tasks?.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    fetchTasks();
  }, []);

  const fetchTasks = async () => {
    try {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("auth_token")}`,
        },
      };
      const res = await axios.get(`${API}/schedule-task/list-all`, config);
      if (res.data.success) {
        const updatedTasks = res.data.result.map((task) => {
          let statusIcon = stopGrey;
          let currentStatus = "stop";
          let btn = "Run";

          switch (task.status) {
            case "Scheduled":
              statusIcon = playGreen;
              currentStatus = "play";
              btn = "Pause";
              break;
            case "Failed":
              statusIcon = pauseOrange;
              currentStatus = "pause";
              btn = "Retry";
              break;
            case "Completed":
              statusIcon = stopGrey;
              currentStatus = "stop";
              btn = "Run";
              break;
            default:
              break;
          }

          return {
            _id: task._id,
            title: task.task,
            id: task.task_id,
            status: task.status,
            created: new Date(task.created_at).toLocaleString(),
            day: task.day || null,
            date: task.date ? task.date : null,
            startDate: task.start_date ? task.start_date : null,
            endDate: task.end_date ? task.end_date : null,
            occurrence: task.occurrence || "N/A",
            priority: task.priority || "N/A",
            result: task.result || "N/A",
            error: task.error || "N/A",
            comments: task.comments || "N/A",
            duration: task.duration || "N/A",
            time: task.time || "N/A",
            statusIcon,
            currentStatus,
            btn,
          };
        });
        setTasks(updatedTasks);
        setLoading(false);
      } else {
        toast.error(res.data.error.msg);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      toast.error(
        "It appears that there is an error in the backend API. Please ensure that you have prepared the system before proceeding with your workflow."
      );
    }
  };

  const handleButtonClick = (id) => {
    setTasks((prevLogs) =>
      prevLogs.map((log) => {
        if (log.id === id) {
          let newBtn;
          let newCurrentStatus = log.currentStatus;
          let newStatusIcon = log.statusIcon;

          if (log.btn === "Pause") {
            newBtn = "Run";
            newCurrentStatus = "pause";
            newStatusIcon = pauseOrange;
          } else if (log.btn === "Run") {
            newBtn = "Pause";
            newCurrentStatus = "play";
            newStatusIcon = playGreen;
          } else if (log.btn === "Retry") {
            newBtn = "Pause";
            newCurrentStatus = "play";
            newStatusIcon = playGreen;
          }

          return {
            ...log,
            btn: newBtn,
            currentStatus: newCurrentStatus,
            statusIcon: newStatusIcon,
          };
        }
        return log;
      })
    );
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Layout>
          <div className="pt-16 ms-[50px] px-5 py-1 h-[100vh] flex flex-col relative">
            <div className="flex justify-between">
              <div className="text-xl mb-3 text-black font-medium">Tasks</div>
              <TasksListDropdown />
            </div>

            {currentItems.length > 0 ? (
              currentItems.map((logItem, index) => (
                <div
                  key={index}
                  className={`border rounded-lg w-100 mb-2 flex ${logItem.currentStatus === "play"
                    ? "border-[#00BB25] bg-[#E5F8E8]"
                    : logItem.currentStatus === "pause"
                      ? "border-[#FA8008] bg-[#FFF3E8]"
                      : "border-[#ABABAB] bg-[#E5E5E5]"
                    }`}
                >
                  {/* <div className="w-10 flex items-center justify-center">
                    <img src={logItem.statusIcon} alt="statusIcon" />
                  </div> */}

                  <div className="w-full border border-l-[#DCDCDC] bg-[#FFFFFF] rounded-lg px-3 flex items-center justify-between gap-3">
                    <TaskListContents logItem={logItem} />
                    <div className="flex items-center gap-3">
                      <TasksListCommentBox
                        logItem={logItem}
                        handleButtonClick={handleButtonClick}
                        fetchTasks={fetchTasks}
                      />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div>No tasks available.</div>
            )}

            <div className="sticky bottom-0 bg-white py-3">
              <Pagination
                data={tasks}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
              />
            </div>
          </div>
        </Layout>
      )}
    </>
  );
};

export default TasksList;
